// extracted by mini-css-extract-plugin
export default {"label":"Search_label__FLsZP","input":"Search_input__aHeSP"};